<template>
    <div>
        <div class="" id="openBookingDetail">
            <div class="route-info scroll-container">
                <div class="route-name">
                    {{campaign.campaignName}}
                    <a id="opbkRule" @click="showRulePopup"><span class="">活动规则</span><img src="https://resource.rcclchina.com.cn/RcclHP/icon08.png"></a>
                </div>
                <div class="route-ship">
                    {{campaign.campaignSubTitle}}
                </div>
            </div>
            <div class="order scroll-container">
                <div class="order-info">
                    <div class="order-row1">
                        <div class="order-row1-l">
                            <div class="order-txt1" v-if="!campaign.isSendCoupon">船票预订号：</div>
                            <div class="order-txt2" v-if="!campaign.isSendCoupon">{{pageData.bookingId || '48小时内生成' }}</div>
                        </div>
                        <div class="order-row1-r">
                            {{statusName}}
                        </div>
                    </div>
                    <div class="order-line"></div>
                </div>

                <div class="order-passenger">
                    <div class="passenger-name">
                        <span class="cn">{{pageData.lastName + pageData.firstName}}</span>

                        <span class="en">{{pageData.lastNamePinyin + " " + pageData.firstNamePinyin}}</span>
                    </div>
                    <div class="passenger-info">
                        <div class="passenger-info-row order-txt4">
                            <p>
                                {{pageData.gender == 'F' ? '女': '男'}}
                            </p>
                            <p>{{pageData.dateOfBirth}}</p>
                        </div>
                        <div class="passenger-info-row order-txt4">
                            <p>{{pageData.telephone}}</p>
                            <p>{{pageData.email}}</p>
                        </div>
                    </div>
                    <div class="order-line"></div>
                </div>
                <div class="order-summary">
                    <div class="openbooking-gift" v-if="isSendGift" @click.prevent="goToGift">
                        查看礼品
                    </div>
                    <div class="order-summary-row">
                        <div class="order-summary-row-l">订金合计</div>
                        <div class="order-summary-row-r"><span>¥</span>{{pageData.amount}}</div>
                    </div>
                </div>
            </div>
            <div class="pay-shorex scroll-container" v-if="pageData.openBookingStatus > 0">
                <div class="shorex-service">
                    <div class="pay-rule-item">
                        <div class="pay-rule-item-line"></div>
                        <p>温馨提醒</p>
                    </div>
                    <div class="shorex-intro">
                        <div class="per-title"></div>
                        <div class="sub-title"></div>
                        <div class="sh">
                            <div></div>
                            <div class="desc" v-html="campaign.campaignDescription">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="toPay-m" v-if="pageData.openBookingStatus == 0&&!isExpired">
            <div class="toPay-m-l">
                <div class="toPay-m-txt">应付总计<span class="unit">￥</span></div>
                <div class="toPay-m-price">
                    {{pageData.amount}}
                </div>
            </div>
            <router-link :to="paymentLink" class="toPay-m-r external">立即支付</router-link>
        </div>

        <OpenBookingRulePopup 
            :isShow="isShowRulePopup"
            :onGoBack="closeRulePopup"
            :rule="rule"
        />
    </div>
</template>

<script>
import api from '@/api'
const OpenBookingRulePopup = () => import ('@/components/Booking/OpenBookingRulePopup')
export default {
    name: "OpenBookingDetail",
    components: {
        OpenBookingRulePopup
    },
    data () {
        return {
            pageData: {},
            isShowRulePopup: false
        }
    },
    beforeMount() {
        this.$store.commit('SET_PAGE_TITLE', '订单详情')
        this.initPage()
        window.onpopstate = () => {
            if (this.isShowRulePopup) {
                this.closeRulePopup()
            }
        }
    },
    mounted() {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: true})
    },
    beforeDestroy () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
        window.onpopstate = () => {}
    },
    methods: {
        async initPage () {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                return this.$router.push({ name: 'Login', query:{ 
                    returnUrl: encodeURIComponent(location.href)
                }})
            }

            const query = this.$router.currentRoute.query
            if (!query || !query.orderId || query.orderId == '') {
                return this.$router.push({ name: 'BookingList' })
            }

            const { success, data } = await api.booking.openBookingDetail({
                orderId: query.orderId,
                userName: userToken
            })
            if (!success) {
                return this.$router.push({ name: 'BookingList' })
            }
            this.pageData = data
        },
        showRulePopup () {
            this.isShowRulePopup = true
            this.showPopup()
        },
        closeRulePopup () {
            this.isShowRulePopup = false
        },
        showPopup() {
            history.pushState({ page: 'openBookingDetail' }, null);
        },
        goToGift () {
            location.href = this.giftLink
        }
    },
    computed: {
        paymentLink () {
            return { name: 'OpenBookingPay', query: { orderId: this.pageData.orderId} }
        },
        campaign () {
            return this.pageData.campaign || {}
        },
        rule () {
            if (!this.campaign.campaignTerms) return ""
            return this.campaign.campaignTerms
        },
        statusName () {
            if (this.pageData.openBookingStatus == 0) {
                return "未付款"
            } else if (this.pageData.openBookingStatus == 10) {
                return "已付款"
            } else if (this.pageData.openBookingStatus == 20) {
                return "已取消"
            } else if (this.pageData.openBookingStatus == 25) {
                return "已使用"
            }
            return ""
        },
        isExpired () {
            const openBookingEndDate = new Date(this.campaign.endDate.trim().substr(0,10))
            return openBookingEndDate < (new Date())
        },
        isSendGift () {
            return this.pageData.openBookingSendGift
        },
        giftLink () {
            const giftLink = `${process.env.VUE_APP_REWARD_URL}/reward/member/shop/gift`
            if (this.userInfo && this.userInfo.userIdentity == 1) {
                return `${giftLink}?token=${this.userInfo.localRewardToken}`
            } else {
                return `/Rccl.UserCenter/CustomerInfo/SignupReward?returnUrl=${encodeURIComponent(giftLink)}`
            }
        }
    }
}
</script>

<style lang="less" scoped>
#openBookingDetail {
    background: #F6F7F8;
    padding: 0px 0 50px 0;
    .route-info {
        margin-bottom: 10px;
        padding: 16px 20px 12px;
        background-color: #fff;
        .route-name {
            padding-bottom: 5px;
            font-size: 14px;
            line-height: 20px;
            color: #333;
            font-weight: bold;
            #opbkRule {
                color: #4A90E2;
                font-size: 12px;
                font-weight: normal;
                position: relative;
                top: -1px;
                span, img {
                    vertical-align: middle;
                }
                img {
                    width: 12px;
                }
            }
        }
        .route-ship {
            font-size: 12px;
            line-height: 16px;
            color: #666;
        }
    }
    .order {
        width: 355px;
        margin: 0 auto 10px;
        padding: 0 10px;
        border-radius: 5px;
        background-color: #fff;
        border: 1px solid #FEBC10;
        border-top: 5px solid #FEBC10;
        -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        .order-info {
            padding-top: 18px;
            .order-row1 {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                .order-row1-l {
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    -moz-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: flex;
                    .order-txt1 {
                        font-size: 14px;
                        line-height: 22px;
                        color: #4A90E2;
                        font-weight: bold;
                    }
                    .order-txt2 {
                        font-size: 14px;
                        line-height: 22px;
                        color: #151515;
                        font-weight: bold;
                    }
                }
                .order-row1-r {
                    font-size: 12px;
                    line-height: 22px;
                    color: #4A90E2;
                }
            }
            .order-line {
                margin-top: 8px;
            }
        }
        .order-passenger {
            padding-top: 16px;
            .passenger-name {
                padding-bottom: 7px;
                font-size: 14px;
                line-height: 20px;
                color: #333;
                font-weight: bold;
                .cn {
                    display: inline-block;
                    margin-right: 20px;
                }
            }
            .passenger-info {
                padding-bottom: 7px;
                .passenger-info-row {
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: flex;
                    padding-bottom: 8px;
                     p {
                        margin: 0 12px 0 0;
                        padding-right: 12px;
                        border-right: 1px solid #999;
                    }
                    p:last-child {
                        margin: 0;
                        padding-right: 0;
                        border-right: none;
                    }
                }
            }
        }
        .order-summary {
            padding-top: 19px;
            padding-bottom: 28px;
            position: relative;
            .order-summary-row {
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: end;
                -webkit-justify-content: flex-end;
                -moz-box-pack: end;
                -ms-flex-pack: end;
                justify-content: flex-end;
                padding-bottom: 8px;
                font-weight: bold;
                .order-summary-row-l {
                    margin-right: 5px;
                    font-size: 14px;
                    line-height: 20px;
                    color: #333;
                }
                .order-summary-row-r {
                    font-size: 15px;
                    line-height: 20px;
                    color: #FF5055;
                    span {
                        display: inline-block;
                        margin-right: 3px;
                        font-size: 15px;
                    }
                }
            }
            .openbooking-gift {
                position: absolute;
                font-size: 12px;
                color: #4A90E2;
                top: 21px;
                font-weight: 700;
                text-decoration: underline;
            }
        }
    }
    .order-line {
        width: 100%;
        height: 1px;
        background: url(https://resource.rcclchina.com.cn/paySuccess/order-line.png) repeat-x;
        -webkit-background-size: auto 100%;
        -o-background-size: auto 100%;
        background-size: auto 100%;
    }

    .order-txt4 {
        font-size: 12px;
        line-height: 1;
        color: #666;
    }

    .shorex-service {
        background: #fff;
        padding: 17px 0 20px;
        margin-bottom: 10px;
        .pay-rule-item {
            display: flex;
            align-items: center;
            font-size: 14px;
            line-height: 20px;
            color: #4A90E2;
            padding-left: 20px;
            position: relative;
            .pay-rule-item-line {
                width: 3px;
                height: 12px;
                margin-right: 6px;
                background-color: #4A90E2;
                p {
                    font-weight: bold;
                    margin: 0;
                }
            }
           
        }
         .shorex-intro {
            padding: 0px 16px 0 28px;
            font-size: 12px;
            .per-title {
                color: #333;
                font-weight: bold;
            }
            .sub-title {
                color: #666;
            }
            .sh {
                display: flex;
                color: #666;
            }
        }
    }
}

.toPay-m {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 10100;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    height: 49px;
    .toPay-m-l {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -moz-box-flex: 0;
        -ms-flex: none;
        flex: none;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        width: 253px;
        padding: 0 20px;
        background-color: #4A90E2;
        color: #fff;
        .toPay-m-txt {
            font-size: 14px;
            line-height: 20px;
            .unit {
                font-size: 12px;
                line-height: 20px;
            }
        }
        .toPay-m-price {
            font-size: 18px;
            line-height: 25px;
            font-weight: bold;
        }
    }
    .toPay-m-r {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -moz-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        font-size: 14px;
        line-height: 1;
        color: #454545;
        letter-spacing: 1px;
        font-weight: bold;
        background: -webkit-gradient(linear, left top, right top, from(#FEBC10), to(#FAD961));
        background: -webkit-linear-gradient(left, #FEBC10, #FAD961);
        background: -moz-linear-gradient(left, #FEBC10, #FAD961);
        background: -o-linear-gradient(left, #FEBC10, #FAD961);
        background: linear-gradient(to right, #FEBC10, #FAD961);
    }
}
</style>